import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import SVG from 'react-inlinesvg';
import styled from 'styled-components';

import { setCurrentUrl } from 'src/common/helpers';
import { Button } from 'src/components/core';
import { useAppSelector } from 'src/hooks';
import { APP_URLS } from 'src/setup/client/app-urls';

const StyledContainer = styled.div`
    ${({ theme: { colors, typography, breakpoints } }) => `
        text-align: center;
        padding: 40px 36.5px;
        border-bottom: 1px solid ${colors.border.light};
        > .button {
            line-height: ${typography.lineHeight[2]};
            padding: 11.89px 0;
        }
        .login-btn {
            margin-bottom: 16px;
        }
        .logo {
            margin: 100px 0px 40px;
            display: inline-block;
            svg {
                path {
                    fill: ${colors.logo};
                }
            }
        }
        @media (min-width: ${breakpoints.md}) and (max-width: ${breakpoints.lg}) {
            padding: 20px 18.25px;
        }
    `}
`;

const NotLogin: FC = () => {
    const { t } = useTranslation();
    const { logo } = useAppSelector((state) => state.global.indexConfig);
    return (
        <StyledContainer>
            <a href={APP_URLS.HOME} className="logo">
                <SVG src={logo} />
            </a>
            <Button
                variant="outlined"
                fullWidth
                className="login-btn"
                onClick={() => setCurrentUrl(APP_URLS.LOGIN)}
            >
                {t('login')}
            </Button>

            <Button fullWidth onClick={() => setCurrentUrl(APP_URLS.REGISTER)}>
                {t('signup')}
            </Button>
        </StyledContainer>
    );
};

export { NotLogin };
